<template>
  <dialog-scroll-lock eager width="400" :persistent="saveStatus.pending" :value="value" @input="$emit('input', false)">

    <error-dialog :status="saveStatus" />

    <v-card>
      <v-btn class="float-right ma-3" icon :disabled="saveStatus.pending" @click="$emit('input', false)">
        <v-icon v-html="mdiClose" />
      </v-btn>
      <v-card-title>Add card</v-card-title>
      <div class="px-4 pt-6 pb-4">
        <v-text-field dense outlined label="Description (optional)" v-model="description" />
        <div style="position: relative;">
          <v-text-field
            dense outlined readonly label="Card" value=" "
            :error="!!cardError" :error-messages="cardError ? [ cardError ] : []"
            :loading="loadStripeCardElementStatus.pending"
          />
          <div ref="card-element" class="mx-3 mt-3" style="position: absolute; top: 0; left: 0; right: 0;" />
        </div>
        <div id="card-errors" role="alert" />
        <div class="mt-1 text-center">
          <img class="d-inline-block" width="120" src="../assets/credit-cards-448.png" />
        </div>
      </div>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="saveStatus.pending" @click="$emit('input', false)">Cancel</v-btn>
        <v-btn color="primary" :disabled="!isCardComplete" :loading="saveStatus.pending" @click="save({ card }, description)">
          Save card
        </v-btn>
      </v-card-actions>
    </v-card>
  </dialog-scroll-lock>
</template>


<script>
import ErrorDialog from '@/components/ErrorDialog.vue';
import { mdiAccount, mdiClose, mdiCreditCard } from '@mdi/js';


export default {
  name: 'add-payment-method-dialog',

  components: {
    ErrorDialog
  },

  props: [ 'value' ],

  data() {
    return {
      description: null,
      card: null,
      isCardComplete: false,
      cardError: null,
      loadStripeCardElementStatus: this.$track('loadStripeCardElement'),
      saveStatus: this.$track('save')
    };
  },

  created() {
    Object.assign(this, { mdiAccount, mdiClose, mdiCreditCard });
  },

  mounted() {
    this.loadStripeCardElement();
  },

  async beforeDestroy() {
    // Stripe leaves around lots of iframes that it shouldn't. There's not a good mechanism for removing these and
    // their listeners, but this seems to work.
    // https://github.com/stripe-archive/react-stripe-elements/issues/99
    // https://gist.github.com/brndnmtthws/c5b28592c321533b8aa6971212295045
    const stripe = await loadStripePromise;
    for (const frame of Object.values(stripe._controller._frames)) {
      frame._iframe.remove();
      frame._removeAllListeners();
    }
  },

  methods: {
    async loadStripeCardElement() {
      const stripe = await loadStripePromise;

      const computed = getComputedStyle(this.$el, null);
      const style = {
        base: {
          color: computed.getPropertyValue('color'),
          fontFamily: computed.getPropertyValue('font-family'),
          fontSize: computed.getPropertyValue('font-size')
        },
        invalid: {
          color: this.$vuetify.theme.defaults.light.error
        }
      };
      this.card = stripe.elements().create('card', { style });
      this.isCardComplete = false;
      this.cardError = null;
      this.card.on('change', e => {
        this.isCardComplete = e.complete;
        this.cardError = e.error ? e.error.message : null;
      });
      this.card.mount(this.$refs['card-element']);
    },

    async save(payment_method, description) {
      const intent = await this.$call('stripe/create-setup-intent');
      const stripe = await loadStripePromise;
      const confirmed = await stripe.confirmCardSetup(intent.client_secret, { payment_method });
      if (confirmed.error)
        throw new VisibleError(confirmed.error.message);
      if (confirmed.setupIntent.status != 'succeeded')
        throw new Error('Unknown');
      const id = await this.$call('stripe/complete-setup-intent', { setup_intent_id: confirmed.setupIntent.id, description });
      this.$emit('complete');
      this.$emit('input', false);
    }
  },

  watch: {
    'saveStatus.pending'(v) {
      this.card && this.card.update({ disabled: v });
    }
  }
}
</script>
